var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openCompanyModal
    ? _c(
        "div",
        [
          _c(
            "modal",
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass:
                        "md-simple md-just-icon md-round modal-default-button",
                      on: { click: _vm.closeSelectionModal },
                    },
                    [_c("md-icon", [_vm._v("clear")])],
                    1
                  ),
                  _c("p", [_vm._v(_vm._s(_vm.heading))]),
                ],
                1
              ),
              _c("template", { slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "company-table" },
                  [
                    _c(
                      "md-table",
                      {
                        attrs: { value: _vm.queriedData, "md-card": "" },
                        on: { "md-selected": _vm.onSelect },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "md-table-row",
                              fn: function (ref) {
                                var item = ref.item
                                return _c(
                                  "md-table-row",
                                  {
                                    class: _vm.getClass(item),
                                    staticStyle: { "text-align": "left" },
                                    attrs: {
                                      "md-selectable": "single",
                                      "md-auto-select": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Company Name" } },
                                      [_vm._v(_vm._s(item.companyName))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Industry" } },
                                      [_vm._v(_vm._s(item.industry))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Sector" } },
                                      [_vm._v(_vm._s(item.sector))]
                                    ),
                                  ],
                                  1
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          833423
                        ),
                      },
                      [
                        _c("md-table-toolbar", [
                          _c(
                            "div",
                            { staticClass: "filter-section" },
                            [
                              _c(
                                "md-field",
                                { staticStyle: { width: "50px" } },
                                [
                                  _c("label", { attrs: { for: "pages" } }, [
                                    _vm._v("Per page"),
                                  ]),
                                  _c(
                                    "md-select",
                                    {
                                      attrs: { name: "pages" },
                                      model: {
                                        value: _vm.pagination.perPage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pagination,
                                            "perPage",
                                            $$v
                                          )
                                        },
                                        expression: "pagination.perPage",
                                      },
                                    },
                                    _vm._l(
                                      _vm.pagination.perPageOptions,
                                      function (item) {
                                        return _c(
                                          "md-option",
                                          {
                                            key: item,
                                            attrs: { label: item, value: item },
                                          },
                                          [_vm._v(" " + _vm._s(item) + " ")]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "md-field",
                                { staticStyle: { margin: "0px 40px" } },
                                [
                                  _c("md-input", {
                                    attrs: {
                                      type: "search",
                                      clearable: "",
                                      placeholder: "Search records",
                                    },
                                    model: {
                                      value: _vm.searchQuery,
                                      callback: function ($$v) {
                                        _vm.searchQuery = $$v
                                      },
                                      expression: "searchQuery",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-success",
                                  on: { click: _vm.openCompanyFilter },
                                },
                                [_vm._v(" Filter")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "data-footer" },
                      [
                        _c("pagination", {
                          staticClass:
                            "pagination-no-border pagination-success",
                          attrs: {
                            "per-page": _vm.pagination.perPage,
                            total: _vm.total,
                            noArrows: false,
                            pageCount: _vm.getPageCount,
                          },
                          model: {
                            value: _vm.pagination.currentPage,
                            callback: function ($$v) {
                              _vm.$set(_vm.pagination, "currentPage", $$v)
                            },
                            expression: "pagination.currentPage",
                          },
                        }),
                        _c("div", {}, [
                          _c("p", { staticClass: "card-category" }, [
                            _vm._v(
                              "Showing " +
                                _vm._s(_vm.from + 1) +
                                " to " +
                                _vm._s(_vm.to) +
                                " of " +
                                _vm._s(_vm.total) +
                                " entries"
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                this.openFilter
                  ? _c(
                      "div",
                      [
                        _c("preferred-companies-filter", {
                          attrs: {
                            companyData: _vm.companies,
                            selectedSectorValue: _vm.filterOnSector,
                            selectedIndustryValue: _vm.filterOnIndustry,
                          },
                          on: {
                            closeFilterModal: _vm.closeFilterModal,
                            industrySelect: _vm.industrySelect,
                            sectorSelect: _vm.sectorSelect,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "filter-section" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success",
                        on: { click: _vm.confirmSelection },
                      },
                      [_vm._v(" Confirm")]
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger",
                        on: { click: _vm.cancelSelection },
                      },
                      [_vm._v(" Cancel")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }